import jsPDF
from "jspdf";

import autoTable
from "jspdf-autotable";

const generarPdfPlan = (
	plan
) => {

	const doc =
		new jsPDF();

	doc.setFontSize(18);

	doc.text(
		"YUTAKE",
		14,
		20
	);

	doc.setFontSize(14);

	doc.text(
		`Plan de Estudio - ${plan.examen}`,
		14,
		30
	);

	doc.setFontSize(10);

	doc.text(
		`Estudiante: ${plan.estudiante}`,
		14,
		40
	);

	doc.text(
		`Fecha: ${plan.fecha}`,
		14,
		48
	);

	doc.text(
		`Fecha objetivo: ${plan.fechaObjetivo}`,
		14,
		56
	);
	
	doc.text(
		`Horas semanales: ${plan.horasSemana}`,
		14,
		64
	);
	
	doc.text(
		`Días restantes: ${plan.diasRestantes}`,
		14,
		72
	);
	
	doc.text(
		`Estado de ruta: ${plan.estadoViabilidad}`,
		14,
		80
	);

	doc.text(
		`Temas explorados: ${plan.resumen.temasExplorados}`,
		14,
		92
	);
	
	doc.text(
		`Temas dominados: ${plan.resumen.temasDominados}`,
		14,
		100
	);

	doc.text(
		"Fortalezas:",
		14,
		115
	);

	plan.fortalezas.forEach(
		(item, index) => {

			doc.text(
				`• ${item}`,
				20,
				92 + (index * 8)
			);
		}
	);

	let y =
	125 +
	(plan.fortalezas.length * 8);

	doc.text(
		"Oportunidades de mejora:",
		14,
		y
	);

	plan.oportunidades.forEach(
		(item, index) => {

			doc.text(
				`• ${item}`,
				20,
				y + 10 + (index * 8)
			);
		}
	);

	const rutaY =
	y +
	20 +
	(
		plan.oportunidades.length * 8
	);

doc.setFontSize(12);

doc.text(
	"Ruta de estudio recomendada",
	14,
	rutaY
);

let lineaY =
	rutaY + 10;

plan.rutaEstudio.forEach(
	materia => {

		doc.setFontSize(11);

		doc.text(
			materia.materia,
			20,
			lineaY
		);

		lineaY += 8;

		doc.setFontSize(10);

		materia.temas.forEach(
			tema => {

				doc.text(
					`• ${tema.nombre}`,
					26,
					lineaY
				);

				lineaY += 7;
			}
		);

		lineaY += 5;
	}
);

doc.addPage();

doc.setFontSize(16);

doc.text(
	"Cronograma de estudio",
	14,
	20
);

let yCronograma = 35;

console.log(
	"SEMANAS PDF:",
	plan.cronograma.length
);

plan.cronograma.forEach(
	semana => {

		if (yCronograma > 250) {

			doc.addPage();

			yCronograma = 20;
		}

		doc.setFontSize(12);

		doc.text(
			`Semana ${semana.semana} (${semana.horas} horas)`,
			14,
			yCronograma
		);

		yCronograma += 8;

		semana.temas.forEach(
			tema => {

				if (yCronograma > 270) {

					doc.addPage();

					yCronograma = 20;
				}

				doc.setFontSize(10);

				doc.text(
					`• ${tema.nombre}`,
					20,
					yCronograma
				);

				yCronograma += 6;
			}
		);

		yCronograma += 8;
	}
);

	doc.addPage();

doc.setFontSize(16);

doc.text(
	"Resumen por Componentes",
	14,
	20
);

autoTable(
	doc,
	{
		startY: 30,

		head: [[
			"Componente",
			"Explorados",
			"Dominados",
			"Estado"
		]],

		body:
			plan.componentes.map(
				c => [

					c.nombre,

					c.explorados,

					c.dominados,

					c.estado
				]
			)
	}
);

const yFinal =
	doc.lastAutoTable
		.finalY + 15;

doc.setFontSize(10);

doc.text(
	"Se recomienda avanzar en los temas propuestos siguiendo el orden sugerido para fortalecer progresivamente los conocimientos requeridos por el examen.",
	14,
	yFinal,
	{
		maxWidth: 180
	}
);

	doc.save(
		`Plan_${plan.examen}.pdf`
	);
};

export default generarPdfPlan;